import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserSocialSecurityFormPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserSocialSecurityFormCollection {
  [IDataKeys.userSocialSecurityForm]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserSocialSecurityFormService {
  static createUserSocialSecurityForm = (
    data: IUserSocialSecurityFormPatchData
  ): Promise<IJSONAPIUserSocialSecurityFormCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_SOCIAL_SECURITY_FORMS,
          data,
        });
        resolve(response as IJSONAPIUserSocialSecurityFormCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_SOCIAL_SECURITY_FORM);
        reject({ error });
      }
    });

  static getUserSocialSecurityForms = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserSocialSecurityFormCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_SOCIAL_SECURITY_FORMS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserSocialSecurityFormCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_SOCIAL_SECURITY_FORMS);
        reject({ error });
      }
    });

  static editUserSocialSecurityForm = (
    id: string,
    data: IUserSocialSecurityFormPatchData
  ): Promise<IJSONAPIUserSocialSecurityFormCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_SOCIAL_SECURITY_FORM(id),
          data,
        });
        resolve(response as IJSONAPIUserSocialSecurityFormCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_SOCIAL_SECURITY_FORM);
        reject({ error });
      }
    });

  static deleteUserSocialSecurityForm = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_SOCIAL_SECURITY_FORM(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_SOCIAL_SECURITY_FORM);
        reject({ error });
      }
    });
}
